module.exports = __webpack_public_path__ + "static/assets/e8bcc33bb6dde98743552d220a8039ec.png";